const methods = ({ request }) => ({
  getPlayerProjections: async ({ year, formulaId, week, position }) =>
    request(`Rankings/${year}/${week}/${position}/${formulaId}`),

  getPredictions: async ({ year, week, formulaId }) =>
    request(`Predictions/Matchups/${year}/${week}/${formulaId}`),

  getPredictionsSeason: async ({ year, formulaId }) =>
  request(`Predictions/Matchups/Season/${year}/${formulaId}`),

  getMatchupAnalysis: async ({ matchupId, formulaId }) =>
    request(`Predictions/Summary/${matchupId}/${formulaId}`),
});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/projections.js